module.exports = __webpack_public_path__ + "static/img/scheme_vidoe.e0bd1d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/scheme_vidoe.png
// module id = QZ9I
// module chunks = 1